<template>
  <div style="width:100%;height:100%;">
    <section style="height:100%;">
     <transition name="breadcrumb">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </transition>
      <transition name="breadcrumb">
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </transition>
    </section>
  </div>
</template>

<script>
// import { generateOne } from '@/utils/i18n'
export default {
  name: 'AppMain',
  data () {
    return {
    }
  },
  computed: {
    // 消息通知 推送
    alarmData () {
      return this.$store.getters.alarmData
    },
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    lang () {
      return this.$store.getters.language
    }
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  watch: {
    $route: {
      handler (n, o) {
        // console.log('this.$route', n)
      },
      deep: true
    }
  },
  methods: {
  }
}
</script>
